<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card flat class="pa-4 mt-4">

            <!-- 1. CLASS WISE -->
            <lazy-observer :onVisible="getTransportClassWiseAnalytics">
        <template v-slot:default>
          <div v-if="loadingClassWiseData" class="text-center py-8">
            <v-skeleton-loader type="image" class="mx-auto" width="900px" height="420px"></v-skeleton-loader>
          </div>
          <div v-else-if="class_wise_transport_data.length" class="d-flex justify-center">
            <!-- Scrollable wrapper - same as Academics -->
            <div class="topic-scrollable-container">
              <div :style="{
                width: '100%',
                maxWidth: '1400px',
                height: Math.max(450, class_wise_transport_data.length * 32) + 'px',
                margin: '0 auto'
              }">
                <chart class="topic-chart-inner" auto-resize :options="class_wise_data"
                  style="width: 100%; height: 100%;"></chart>
              </div>
            </div>
          </div>
          <div v-else class="text-center pa-8 grey--text text-h6">No class-wise data available</div>
        </template>
      </lazy-observer>

            <v-divider class="my-12"></v-divider>

            <!-- 2. GRADE WISE -->
            <lazy-observer :onVisible="getTransportGradeWiseAnalytics">
                <template v-slot:default>
                    <div v-if="loadingGradeWiseData" class="text-center py-8">
                        <v-skeleton-loader type="image" class="mx-auto" width="900px"
                            height="420px"></v-skeleton-loader>
                    </div>
                    <div v-else-if="grade_wise_transport_data.length" class="d-flex justify-center">
                        <!-- <div style="width: 900px; height: 420px;"> -->
                        <div :style="{
                            width: '1200px',  
                            height: Math.max(400, grade_wise_transport_data.length * 50) + 'px' 
                          }">
                            <chart style="width: 100%; height: 100%;" auto-resize :options="grade_wise_data"></chart>
                        </div>
                    </div>
                    <div v-else class="text-center pa-8 grey--text text-h6">No grade-wise data available</div>
                </template>
            </lazy-observer>

            <v-divider class="my-12"></v-divider>

            <!-- 3. FEES EVALUATION – EXACTLY LIKE YOUR OLD PAGE (PERFECT) -->
            <lazy-observer :onVisible="getTransportFeesEvaluation">
                <template v-slot:default>
                    <div v-if="loadingFeesEvaluation" class="text-center py-8">
                        <v-skeleton-loader type="image" class="mx-auto" width="1200px"
                            height="520px"></v-skeleton-loader>
                    </div>

                    <div v-else-if="expectedCollection > 0 || actualCollection > 0"
                        class="d-flex align-center justify-center px-8"
                        style="min-height:520px; gap:70px; flex-wrap:nowrap;">

                        <!-- PIE CHART -->
                        <div style="width:550px; height:480px; flex-shrink:0;">
                            <chart style="width:100%; height:100%;" auto-resize :options="fees_collection_data"></chart>
                        </div>

                        <!-- 3 BOXES – 100% SAME AS OLD PAGE -->
                        <div class="d-flex flex-column justify-center" style="gap: 16px;">
                            <!-- Actual Collection -->
                            <v-card flat class="pa-3 text-center" :style="{
                                background: 'linear-gradient(135deg, #f9c80e, #ff9a00)',
                                color: 'white',
                                borderRadius: '12px',
                                minWidth: '140px'
                            }">
                                <div class="font-weight-medium">Actual Collection</div>
                                <div class="text-h6 font-weight-bold">{{ actualCollection }} {{ CollectionUnit }}</div>
                            </v-card>

                            <!-- Expected Collection -->
                            <v-card flat class="pa-3 text-center" :style="{
                                background: 'linear-gradient(135deg, #1f139e, #43bccd)',
                                color: 'white',
                                borderRadius: '12px',
                                minWidth: '140px'
                            }">
                                <div class="font-weight-medium">Expected Collection</div>
                                <div class="text-h6 font-weight-bold">{{ expectedCollection }} {{ CollectionUnit }}
                                </div>
                            </v-card>

                            <!-- Total Dues -->
                            <v-card flat class="pa-3 text-center" :style="{
                                background: 'linear-gradient(135deg, #f95738, #ef233c)',
                                color: 'white',
                                borderRadius: '12px',
                                minWidth: '140px'
                            }">
                                <div class="font-weight-medium">Total Dues</div>
                                <div class="text-h6 font-weight-bold">{{ due }} {{ CollectionUnit }}</div>
                            </v-card>
                        </div>

                    </div>

                    <!-- <div v-else class="text-center pa-8 grey--text text-h6">No fees collection data</div> -->
                </template>
            </lazy-observer>

            <!-- <v-divider class="my-12"></v-divider> -->

            <!-- 4. GRADE WISE COLLECTION -->
            <lazy-observer :onVisible="getTransportFeesCollectionByGrade">
                <template v-slot:default>
                    <div v-if="loadingFeesCollection" class="text-center py-8">
                        <v-skeleton-loader type="image" class="mx-auto" width="900px"
                            height="420px"></v-skeleton-loader>
                    </div>
                    <div v-else-if="standardWiseCollection.length" class="d-flex justify-center">
                        <div style="width: 900px; height: 420px;">
                            <chart style="width: 100%; height: 100%;" auto-resize
                                :options="grade_wise_fees_collection_data"></chart>
                        </div>
                    </div>
                    <!-- <div v-else class="text-center pa-8 grey--text text-h6">No collection data by grade</div> -->
                </template>
            </lazy-observer>

            <!-- <v-divider class="my-12"></v-divider> -->

            <!-- 5. GRADE WISE DUES -->
           <!-- 5. GRADE WISE DUES -->
<lazy-observer :onVisible="getTransportFeesDueByGrade">
    <template v-slot:default>
        <div v-if="loadingFeesDue" class="text-center py-8">
            <v-skeleton-loader type="image" class="mx-auto" width="900px"
                height="420px"></v-skeleton-loader>
        </div>
        <div v-else-if="standardWiseDues.length" class="d-flex justify-center">
            <div style="width: 900px; height: 420px;">
                <chart style="width: 100%; height: 100%;" auto-resize :options="grade_wise_fees_due_data"></chart>
            </div>
        </div>
        <div v-else class="text-center pa-8 grey--text text-h6">No dues data by grade</div>
    </template>
</lazy-observer>

            <!-- <v-divider class="my-12"></v-divider> -->

            <!-- 6. PAYMENT STATS -->
            <lazy-observer :onVisible="getTransportPaymentStatsByGrade">
                <template v-slot:default>
                    <div v-if="loadingPaymentStats" class="text-center py-8">
                        <v-skeleton-loader type="image" class="mx-auto" width="900px"
                            height="420px"></v-skeleton-loader>
                    </div>
                    <div v-else-if="paymentStatsByStandard.length" class="d-flex justify-center">
                        <div style="width: 900px; height: 420px;">
                            <chart style="width: 100%; height: 100%;" auto-resize
                                :options="grade_wise_payment_stats_data"></chart>
                        </div>
                    </div>
                    <!-- <div v-else class="text-center pa-8 grey--text text-h6">No payment stats available</div> -->
                </template>
            </lazy-observer>

        </v-card>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "TransportAnalyticsDashboard",
    props: ['selected_ay', 'selected_standard', 'selected_div'],

    data() {
        return {
            snackbar: false,
            color: "",
            snackbar_msg: "",

            loadingClassWiseData: false,
            loadingGradeWiseData: false,
            loadingFeesEvaluation: false,
            loadingFeesCollection: false,
            loadingFeesDue: false,
            loadingPaymentStats: false,
standardWiseDues: [],
            class_wise_transport_data: [],
            grade_wise_transport_data: [],
            standardWiseCollection: [],
            paymentStatsByStandard: [],
            expectedCollection: "",
            actualCollection: "",
            due: "",
            CollectionUnit: "Lakh",

            cache: { classwise: {}, gradewise: {}, feeseval: {}, feescollection: {}, feesdue: {}, paymentstats: {} },

            class_wise_data: {
    title: { text: "Transport Class Wise Analysis", left: "center" },
    color: [
        "#7fa74b",     // School Bus - solid green
        "#f2e8cf",     // Parent Pick-up - beige
        "#6c4fc3"      // Self - purple
    ],
    tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: function (params) {
            let result = params[0].name + "<br/>";
            params.forEach(p => {
                if (p.value > 0) {
                    result += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
                }
            });
            return result || params[0].name + "<br/>No data";
        }
    },
    toolbox: {
        show: true,
        feature: {
            magicType: { show: true, type: ["line", "bar", "stack"] },
            restore: { show: true },
            saveAsImage: { show: true }
        }
    },
    legend: { 
        data: ["School Bus", "Parent Pick-up", "Self"], 
        bottom: 10,
        itemGap: 20
    },
    grid: {
        left: "20%",       // ← Increased to give more space for long class/division names
        right: "20%",
        top: 60,
        bottom: 60,        // ← More bottom space for legend
        containLabel: true
    },
    xAxis: {
        type: "value",
        name: "Number of Students",
        nameLocation: "middle",
        nameGap: 70,
        min: 0,
        axisLabel: { fontSize: 12 },
        splitLine: { show: true, lineStyle: { type: "dashed" } }
    },
    yAxis: {
        type: "category",
        name: "Class / Division",
        nameLocation: "middle",
        nameGap: 180,      // ← More space for Y-axis title
        inverse: true,
        data: [],
        axisLabel: {
            interval: 0,
            fontSize: 12,
            width: 200,                    // Allow wider labels
            overflow: "break",             // Wrap long labels if needed (or use "truncate")
            align: "right",
            formatter: function (value) {
                // Optional: wrap very long names
                return value.length > 25 ? value.match(/.{1,25}/g).join("\n") : value;
            }
        },
        axisTick: { alignWithLabel: true }
    },
    series: [
        {
            name: "School Bus",
            type: "bar",
            barWidth: 5,                  // ← Thinner bars like in your example
            barCategoryGap: "50%",         // ← More vertical space between classes
            barGap: "30%",                 // ← Space between the 3 bars in same row
            data: [],
            label: {
                show: true,
                position: "right",
                formatter: p => p.value > 0 ? p.value : ""
            },
            itemStyle: { borderRadius: [0, 6, 6, 0] }
        },
        {
            name: "Parent Pick-up",
            type: "bar",
            barWidth: 5,
            barCategoryGap: "50%",
            barGap: "30%",
            data: [],
            label: {
                show: true,
                position: "right",
                formatter: p => p.value > 0 ? p.value : ""
            },
            itemStyle: { borderRadius: [0, 6, 6, 0] }
        },
        {
            name: "Self",
            type: "bar",
            barWidth: 5,
            barCategoryGap: "50%",
            barGap: "30%",
            data: [],
            label: {
                show: true,
                position: "right",
                formatter: p => p.value > 0 ? p.value : ""
            },
            itemStyle: { borderRadius: [0, 6, 6, 0] }
        }
    ]
},

            grade_wise_data: {
                title: { text: "Transport Grade Wise Analysis", left: "center" },
                color: [
                    "#7fa74b",   // School Bus - solid green
                    "#f2e8cf",   // Parent Pick-up - beige
                    "#6c4fc3"    // Self - purple
                ],
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    formatter: function (params) {
                        let result = params[0].name + "<br/>";
                        params.forEach(p => {
                            if (p.value > 0) {
                                result += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
                            }
                        });
                        return result || params[0].name + "<br/>No data";
                    }
                },
                toolbox: {
                    show: true,
                    feature: {
                        magicType: { show: true, type: ["line", "bar", "stack"] },
                        restore: { show: true },
                        saveAsImage: { show: true }
                    }
                },
                legend: {
                    data: ["School Bus", "Parent Pick-up", "Self"],
                    itemGap: 20,
                    bottom: 10
                },
                grid: {
                    left: "25%",      // More space on left for grade names
                    right: "8%",
                    top: 80,
                    bottom: 80,
                    containLabel: true
                },
                xAxis: {
                    type: "value",
                    name: "Number of Students",
                    nameLocation: "middle",
                    nameGap: 90,
                    min: 0,
                    axisLabel: { fontSize: 12 },
                    splitLine: { show: true, lineStyle: { type: "dashed" } }
                },
                yAxis: {
                    type: "category",
                    name: "Grade",
                    nameLocation: "middle",
                    nameGap: 140,
                    inverse: true,
                    nameTextStyle: {fontSize: 14 },
                    data: [],
                    axisLabel: {
                        interval: 0,
                        fontSize: 12,
                        width: 180,
                        overflow: "truncate",
                        align: "right",
                        formatter: function (value) {
                            return value.length > 20 ? value.substr(0, 20) + "..." : value;
                        }
                    },
                    axisTick: { alignWithLabel: true }
                },
                series: [
                    {
                        name: "School Bus",
                        type: "bar",
                        barWidth: 9,                 // Slightly thinner for clean grouping
                        barCategoryGap: "35%",        // Good vertical spacing between grades
                        barGap: "30%",               // ← CRITICAL FIX: Negative = proper grouped bars (no overlap)
                        data: [],
                        label: {
                            show: true,
                            position: "right",
                            fontWeight: "bold",
                            formatter: p => p.value > 0 ? p.value : ""
                        },
                        itemStyle: { borderRadius: [0, 8, 8, 0] }
                    },
                    {
                        name: "Parent Pick-up",
                        type: "bar",
                        barWidth: 9,
                        barCategoryGap: "35%",
                        barGap: "30%",               // ← Same here
                        data: [],
                        label: {
                            show: true,
                            position: "right",
                            fontWeight: "bold",
                            formatter: p => p.value > 0 ? p.value : ""
                        },
                        itemStyle: { borderRadius: [0, 8, 8, 0] }
                    },
                    {
                        name: "Self",
                        type: "bar",
                        barWidth: 9,
                        barCategoryGap: "35%",
                        barGap: "30%",               // ← And here
                        data: [],
                        label: {
                            show: true,
                            position: "right",
                            fontWeight: "bold",
                            formatter: p => p.value > 0 ? p.value : ""
                        },
                        itemStyle: { borderRadius: [0, 8, 8, 0] }
                    }
                ]
            },
               
            fees_collection_data: {
                title: { text: "Expected Collection vs Actual Collection", left: "center" },
                color: [
                    { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "#1f139e" }, { offset: 1, color: "#43bccd" }] },
                    { type: "linear", x: 0, y: 0, x2: 1, y2: 1, colorStops: [{ offset: 0, color: "#f9c80e" }, { offset: 1, color: "#ff9a00" }] }
                ],
                tooltip: { trigger: "item", formatter: '{a} <br/>{b} : {c} ({d}%)' },
                legend: { itemGap: 15, bottom: 0, data: ["Expected Collection", "Actual Collection"] },
                series: [{
                    name: "Collection",
                    type: "pie",
                    radius: "50%",
                    center: ["50%", "50%"],
                    data: [{ value: 0, name: "Expected Collection" }, { value: 0, name: "Actual Collection" }],
                    emphasis: { itemStyle: { shadowBlur: 10, shadowOffsetX: 0, shadowColor: "rgba(0,0,0,0.5)" } }
                }]
            },

            grade_wise_fees_collection_data: {
    title: { 
        text: "Grade Wise Fees Collections", 
        left: "center",
        top: 20,
        textStyle: { fontWeight: "bold", fontSize: 16 }
    },
    color: [
        { type: "linear", x: 0, y: 0, x2: 0, y2: 1, 
          colorStops: [{ offset: 0, color: "#90e0ef" }, { offset: 1, color: "#00b4d8" }] }
    ],
    tooltip: { 
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: function(params) {
            if (params.length > 0) {
                const val = params[0].value;
                const formatted = val >= 100000 
                    ? (val / 100000).toFixed(1) + "L" 
                    : val.toLocaleString();
                return `${params[0].name}<br/>${params[0].marker} Collected: ${formatted} Rs.`;
            }
            return "";
        }
    },
    toolbox: {
        show: true,
        feature: {
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true }
        }
    },
    grid: {
        left: "10%",
        right: "8%",
        top: 80,
        bottom: 100,   // Extra space for rotated labels
        containLabel: true
    },
    xAxis: {
        type: "category",
        name: "Class",
        nameLocation: "middle",
        nameGap: 50,
        data: [], // populated dynamically
        axisLabel: {
            rotate: 45,        // Rotate to fit all labels without overlap
            fontSize: 11,
            interval: 0,       // FORCE all labels to show
            align: "right",
            margin: 8
        },
        axisTick: { alignWithLabel: true }
    },
    yAxis: {
        type: "value",
        name: "Amount in Lakhs Rs.",
        nameLocation: "middle",
        nameGap: 80,
        nameRotate: 90,
        axisLabel: {
            formatter: function(value) {
                return (value / 100000).toFixed(0) + "L";
            }
        },
        splitLine: { lineStyle: { type: "dashed" } }
    },
    series: [{
        name: "Collected",
        type: "bar",
        barWidth: 30,               // Narrow fixed width for many bars
        barCategoryGap: "20%",      // Tighter spacing between bars
        data: [],
        label: {
            show: true,
            position: "top",
            fontWeight: "bold",
            fontSize: 12,
            formatter: function(param) {
                if (param.value >= 100000) {
                    return (param.value / 100000).toFixed(0) + "L";
                }
                return param.value > 0 ? param.value.toLocaleString() : "";
            }
        },
        itemStyle: {
            borderRadius: [8, 8, 0, 0],
            shadowBlur: 10,
            shadowColor: "rgba(0, 180, 216, 0.3)"
        }
    }]
},

            grade_wise_fees_due_data: {
    title: { 
        text: "Grade Wise Fees Dues", 
        left: "center",
        top: 20,
        textStyle: { fontWeight: "bold", fontSize: 16 }
    },
    color: [
        { type: "linear", x: 0, y: 0, x2: 0, y2: 1, 
          colorStops: [{ offset: 0, color: "#ff9ebb" }, { offset: 1, color: "#fd3e81" }] }
    ],
    tooltip: { 
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: function(params) {
            if (params.length > 0) {
                const val = params[0].value;
                const formatted = val >= 100000 
                    ? (val / 100000).toFixed(1) + "L" 
                    : val.toLocaleString();
                return `${params[0].name}<br/>${params[0].marker} Dues: ${formatted} Rs.`;
            }
            return "";
        }
    },
    toolbox: {
        show: true,
        feature: {
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true }
        }
    },
    grid: {
        left: "10%",
        right: "8%",
        top: 80,
        bottom: 90,   // Increased bottom space for long labels
        containLabel: true
    },
    xAxis: {
        type: "category",
        name: "Class",
        nameLocation: "middle",
        nameGap: 50,
        data: [],
        axisLabel: {
            rotate: 45,           // ← Rotate labels to prevent overlap
            fontSize: 11,
            interval: 0,          // Show all labels
            align: "right",
            margin: 8
        },
        axisTick: { 
            alignWithLabel: true 
        }
    },
    yAxis: {
        type: "value",
        name: "Amount in Lakhs Rs.",
        nameLocation: "middle",
        nameGap: 85,
        nameRotate: 90,
        axisLabel: {
            formatter: function(value) {
                return (value / 100000).toFixed(0) + "L";
            }
        },
        splitLine: { lineStyle: { type: "dashed" } }
    },
    series: [{
        name: "Dues",
        type: "bar",
        barWidth: 30,              // ← Fixed pixel width instead of percentage
        barCategoryGap: "20%",     // ← Controls gap between bars (smaller = tighter)
        // barMaxWidth: 40,        // Optional: limit max bar width
        data: [],
        label: {
            show: true,
            position: "top",
            fontWeight: "bold",
            fontSize: 12,
            color: "#333",
            formatter: function(param) {
                if (param.value >= 100000) {
                    return (param.value / 100000).toFixed(0) + "L";
                }
                if (param.value >= 1000) {
                    return param.value.toLocaleString();
                }
                return param.value > 0 ? param.value : "";
            }
        },
        itemStyle: {
            borderRadius: [8, 8, 0, 0],
            shadowBlur: 10,
            shadowColor: "rgba(253, 62, 129, 0.3)"
        }
    }]
},

            grade_wise_payment_stats_data: {
    title: { text: "Payment on Time vs Late Payment", left: "center", top: 20, textStyle: { fontWeight: "bold", fontSize: 16 } },
    color: [
        { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "#6cb1c3" }, { offset: 1, color: "#1985a1" }] },
        { type: "linear", x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: "#868689" }, { offset: 1, color: "#46494c" }] }
    ],
    tooltip: { 
        trigger: "axis", 
        axisPointer: { type: "shadow" },
        formatter: function(params) {
            let result = params[0].name + "<br/>";
            params.forEach(p => {
                if (p.value > 0) {
                    result += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
                }
            });
            return result;
        }
    },
    toolbox: { 
        show: true, 
        feature: { 
            magicType: { show: true, type: ["line", "bar", "stack"] }, 
            restore: { show: true }, 
            saveAsImage: { show: true } 
        } 
    },
    legend: { data: ["Paid on Time", "Late Payments"], itemGap: 20, bottom: 10 },
    grid: { 
        left: "10%", 
        right: "8%", 
        top: 80, 
        bottom: 100,  // More space for rotated labels
        containLabel: true 
    },
    xAxis: { 
        type: 'category', 
        name: 'Class', 
        nameLocation: 'middle', 
        nameGap: 60,
        data: [], 
        axisLabel: { 
            rotate: 45,       // Rotate to prevent overlap and show ALL labels
            fontSize: 11,
            interval: 0,      // Critical: forces ALL labels to show
            align: 'right',
            margin: 8
        },
        axisTick: { alignWithLabel: true }
    },
    yAxis: { 
        type: "value", 
        name: "Number of Students", 
        nameLocation: "middle", 
        nameGap: 60,
        nameRotate: 90,
        min: 0,
        axisLabel: { fontSize: 12 },
        splitLine: { lineStyle: { type: "dashed" } }
    },
    series: [
        { 
            name: "Paid on Time", 
            data: [], 
            type: "bar", 
            barWidth: 20,           // Narrow bars for many categories
            barGap: "30%",          // Space between the two series
            label: { 
                show: true, 
                position: "top",
                formatter: p => p.value > 0 ? p.value : ""
            },
            itemStyle: { borderRadius: [4, 4, 0, 0] }
        },
        { 
            name: "Late Payments", 
            data: [], 
            type: "bar", 
            barWidth: 20,
            barGap: "30%",
            label: { 
                show: true, 
                position: "top",
                formatter: p => p.value > 0 ? p.value : ""
            },
            itemStyle: { borderRadius: [4, 4, 0, 0] }
        }
    ]
}
        };
    },

    computed: {
        filterKey() {
            return `${this.selected_ay || ''}|${this.selected_standard || ''}|${this.selected_div || ''}`;
        }
    },

    watch: {
        selected_ay() { this.onFilterChange(); },
        selected_standard() { this.onFilterChange(); },
        selected_div() { this.onFilterChange(); }
    },

    created() {
        this.$options.components.LazyObserver = {
            props: { onVisible: { type: Function, required: true } },
            data: () => ({ loaded: false }),
            mounted() {
                const observer = new IntersectionObserver((entries) => {
                    if (entries[0].isIntersecting && !this.loaded) {
                        this.loaded = true;
                        this.onVisible();
                        observer.disconnect();
                    }
                }, { threshold: 0.1 });
                observer.observe(this.$el);
            },
            render(h) {
                return this.loaded ? ((this.$slots.default && this.$slots.default[0]) ? this.$slots.default[0] : h("div")) : h("div");
            }
        };
    },

    methods: {
        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        },

        onFilterChange() {
            this.clearAllData();
            this.cache = { classwise: {}, gradewise: {}, feeseval: {}, feescollection: {}, feesdue: {}, paymentstats: {} };
        },

        clearAllData() {
            this.class_wise_transport_data = [];
            this.grade_wise_transport_data = [];
            this.standardWiseCollection = [];
            this.paymentStatsByStandard = [];
            this.expectedCollection = "";
            this.actualCollection = "";
            this.due = "";
            this.CollectionUnit = "Lakh";

            this.class_wise_data.xAxis.data = [];
            this.class_wise_data.series.forEach(s => s.data = []);

            this.grade_wise_data.xAxis.data = [];
            this.grade_wise_data.series.forEach(s => s.data = []);

            this.fees_collection_data.series[0].data = [{ value: 0, name: "Expected Collection" }, { value: 0, name: "Actual Collection" }];

            this.grade_wise_fees_collection_data.xAxis.data = [];
            this.grade_wise_fees_collection_data.series[0].data = [];

            this.grade_wise_fees_due_data.xAxis.data = [];
            this.grade_wise_fees_due_data.series[0].data = [];

            this.grade_wise_payment_stats_data.xAxis.data = [];
            this.grade_wise_payment_stats_data.series.forEach(s => s.data = []);
        },

        async getTransportClassWiseAnalytics() {
            if (this.cache.classwise[this.filterKey]) { this.class_wise_transport_data = this.cache.classwise[this.filterKey]; this.populateClassWiseChart(); return; }
            this.loadingClassWiseData = true;
            try {
                const res = await axios.post("/adminDashboard/getTransportClassWiseAnalytics", { academicyearId: this.selected_ay, standardIds: this.selected_standard, divisionIds: this.selected_div });
                if (res.data.flag === "YES") {
                    this.class_wise_transport_data = res.data.class_wise_transport_data || [];
                    this.populateClassWiseChart();
                    this.cache.classwise[this.filterKey] = this.class_wise_transport_data;
                }
            } catch { this.showSnackbar("error", "Failed to load class-wise data"); }
            finally { this.loadingClassWiseData = false; }
        },

       populateClassWiseChart() {
    // Sort classes logically (I-A, II-B, ..., XII) - handles Roman numerals + letters
    const sortedData = [...this.class_wise_transport_data].sort((a, b) => {
        return a.standardDivision.localeCompare(b.standardDivision, undefined, {
            numeric: true,
            sensitivity: "base"
        });
    });

    this.class_wise_data.yAxis.data = sortedData.map(i => i.standardDivision);

    // Fill data - zeros are allowed but labels/bars will be hidden via formatter
    this.class_wise_data.series[0].data = sortedData.map(i => i.schoolBus || 0);
    this.class_wise_data.series[1].data = sortedData.map(i => i.parentPick || 0);
    this.class_wise_data.series[2].data = sortedData.map(i => i.self || 0);
},

        async getTransportGradeWiseAnalytics() {
            if (this.cache.gradewise[this.filterKey]) { this.grade_wise_transport_data = this.cache.gradewise[this.filterKey]; this.populateGradeWiseChart(); return; }
            this.loadingGradeWiseData = true;
            try {
                const res = await axios.post("/adminDashboard/getTransportGradeWiseAnalytics", { academicyearId: this.selected_ay, standardIds: this.selected_standard });
                if (res.data.flag === "YES") {
                    this.grade_wise_transport_data = res.data.grade_wise_transport_data || [];
                    this.populateGradeWiseChart();
                    this.cache.gradewise[this.filterKey] = this.grade_wise_transport_data;
                }
            } catch { this.showSnackbar("error", "Failed to load grade-wise data"); }
            finally { this.loadingGradeWiseData = false; }
        },

        populateGradeWiseChart() {
            // this.grade_wise_data.xAxis.data = this.grade_wise_transport_data.map(i => i.standardName);
            this.grade_wise_data.yAxis.data = this.grade_wise_transport_data.map(
    i => i.standardName
);

            this.grade_wise_data.series[0].data = this.grade_wise_transport_data.map(i => i.school_transport);
            this.grade_wise_data.series[1].data = this.grade_wise_transport_data.map(i => i.parent_pickup);
            this.grade_wise_data.series[2].data = this.grade_wise_transport_data.map(i => i.self);
        },

        async getTransportFeesEvaluation() {
            if (this.cache.feeseval[this.filterKey]) return;
            this.loadingFeesEvaluation = true;
            try {
                const res = await axios.post("/adminDashboard/getTransportFeesEvaluation", { 
                    academicyearId: this.selected_ay,
                    standardIds: this.selected_standard,   
            divisionIds: this.selected_div
                });
                if (res.data.flag === "YES") {
                    this.expectedCollection = res.data.expectedCollection || 0;
                    this.actualCollection = res.data.actualCollection || 0;
                    this.due = res.data.due || 0;
                    this.CollectionUnit = res.data.CollectionUnit || "Lakh";
                    this.fees_collection_data.series[0].data = [
                        { value: this.expectedCollection, name: "Expected Collection" },
                        { value: this.actualCollection, name: "Actual Collection" }
                    ];
                    this.cache.feeseval[this.filterKey] = true;
                }
            } catch { this.showSnackbar("error", "Failed to load fees evaluation"); }
            finally { this.loadingFeesEvaluation = false; }
        },

        // async getTransportFeesCollectionByGrade() {
        //     if (this.cache.feescollection[this.filterKey]) { this.standardWiseCollection = this.cache.feescollection[this.filterKey]; this.populateFeesCollectionChart(); return; return; }
        //     this.loadingFeesCollection = true;
        //     try {
        //         const res = await axios.post("/adminDashboard/getTransportFeesCollectionByGrade", { academicyearId: this.selected_ay, standardIds: this.selected_standard });
        //         if (res.data.flag === "YES") {
        //             this.standardWiseCollection = res.data.standardWiseCollection || [];
        //             this.populateFeesCollectionChart();
        //             this.cache.feescollection[this.filterKey] = this.standardWiseCollection;
        //         }
        //     } catch { this.showSnackbar("error", "Failed to load collection data"); }
        //     finally { this.loadingFeesCollection = false; }
        // },
async getTransportFeesCollectionByGrade() {
    if (this.cache.feescollection[this.filterKey]) {
        this.standardWiseCollection = this.cache.feescollection[this.filterKey];
        this.populateFeesCollectionChart();
        return;
    }
    this.loadingFeesCollection = true;
    try {
        const res = await axios.post("/adminDashboard/getTransportFeesCollectionByGrade", {
            academicyearId: this.selected_ay,
            standardIds: this.selected_standard
        });
        if (res.data.flag === "YES") {
            // THIS IS CORRECT
            this.standardWiseCollection = res.data.standardWiseCollection || [];
            this.populateFeesCollectionChart();
            this.cache.feescollection[this.filterKey] = this.standardWiseCollection;
        }
    } catch (e) {
        console.error(e);
        this.showSnackbar("error", "Failed to load collection data");
    } finally {
        this.loadingFeesCollection = false;
    }
},
        populateFeesCollectionChart() {
    // Sort standards logically
    const sorted = [...this.standardWiseCollection].sort((a, b) => {
        return a.standardName.localeCompare(b.standardName, undefined, {
            numeric: true,
            sensitivity: "base"
        });
    });

    this.grade_wise_fees_collection_data.xAxis.data = sorted.map(i => i.standardName);
    this.grade_wise_fees_collection_data.series[0].data = sorted.map(i => i.actualCollection || 0);
},

async getTransportFeesDueByGrade() {
    if (this.cache.feesdue[this.filterKey]) {
        this.standardWiseDues = this.cache.feesdue[this.filterKey];  // ← NEW VARIABLE
        this.populateFeesDueChart();
        return;
    }
    this.loadingFeesDue = true;
    try {
        const res = await axios.post("/adminDashboard/getTransportFeesDueByGrade", {
            academicyearId: this.selected_ay,
            standardIds: this.selected_standard
        });
        if (res.data.flag === "YES") {
            // READ THE CORRECT KEY
            this.standardWiseDues = res.data.standardWiseDues || [];  // ← standardWiseDues, not standardWiseCollection
            this.populateFeesDueChart();
            this.cache.feesdue[this.filterKey] = this.standardWiseDues;
        }
    } catch (e) {
        console.error(e);
        this.showSnackbar("error", "Failed to load due data");
    } finally {
        this.loadingFeesDue = false;
    }
},
        populateFeesDueChart() {
    // Sort standards in logical order (I, IV, Nursery, VI, X, XII Sci)
    const sorted = [...this.standardWiseDues].sort((a, b) => {
        return a.standardName.localeCompare(b.standardName, undefined, {
            numeric: true,
            sensitivity: "base"
        });
    });

    this.grade_wise_fees_due_data.xAxis.data = sorted.map(i => i.standardName);
    this.grade_wise_fees_due_data.series[0].data = sorted.map(i => i.dueCollection || 0);
},

        async getTransportPaymentStatsByGrade() {
            if (this.cache.paymentstats[this.filterKey]) { this.paymentStatsByStandard = this.cache.paymentstats[this.filterKey]; this.populatePaymentStatsChart(); return; }
            this.loadingPaymentStats = true;
            try {
                const res = await axios.post("/adminDashboard/getTransportPaymentStatsByGrade", { academicyearId: this.selected_ay, standardIds: this.selected_standard });
                if (res.data.flag === "YES") {
                    this.paymentStatsByStandard = res.data.paymentStatsByStandard || [];
                    this.populatePaymentStatsChart();
                    this.cache.paymentstats[this.filterKey] = this.paymentStatsByStandard;
                }
            } catch { this.showSnackbar("error", "Failed to load payment stats"); }
            finally { this.loadingPaymentStats = false; }
        },

        populatePaymentStatsChart() {
    // Sort standards logically (Nursery, I, II, ..., XII Sci)
    const sorted = [...this.paymentStatsByStandard].sort((a, b) => {
        return a.standardName.localeCompare(b.standardName, undefined, {
            numeric: true,
            sensitivity: "base"
        });
    });

    this.grade_wise_payment_stats_data.xAxis.data = sorted.map(i => i.standardName);
    this.grade_wise_payment_stats_data.series[0].data = sorted.map(i => i.onTimeCount || 0);
    this.grade_wise_payment_stats_data.series[1].data = sorted.map(i => i.lateCount || 0);
}
    }
};
</script>

<style scoped>
.chart {
    margin: 0 auto;
}
.topic-scrollable-container {
  height: 650px;                  /* Fixed visible height - adjust if needed */
  width: 100%;
  max-width: 1400px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  padding: 16px 0;
  margin: 0 auto;
}

/* Thin elegant scrollbar */
.topic-scrollable-container::-webkit-scrollbar {
  width: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 10px;
}
.topic-scrollable-container::-webkit-scrollbar-thumb {
  background: #c0c0c0;
  border-radius: 10px;
  border: 2px solid #f5f5f5;
}
.topic-scrollable-container::-webkit-scrollbar-thumb:hover {
  background: #a0a0a0;
}

/* Inner chart class (used in Academics - keeping same for consistency) */
.topic-chart-inner {
  width: 100%;
  height: 100%;
}
</style>